export default __webpack_public_path__ + "static/media/avd_ikon.cfad3bbf.png";